export default __webpack_public_path__ + "static/media/trash.c18b373b.svg";